export default __webpack_public_path__ + "16a3fca3352e1195f0928a0376527bcb.gif";